import React, { useEffect, useState } from "react";
import { Youtube, Twitter, Instagram, MessageSquare, Send } from "lucide-react";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../../modules/auth/firebaseConfig";

export default function SocialConnectHub({ userEmail }) {
  const [links, setLinks] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSocialLinks() {
      const ref = doc(db, "users", userEmail);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        setLinks(snap.data().socialLinks || {});
      }
      setLoading(false);
    }
    fetchSocialLinks();
  }, [userEmail]);

  if (loading) return <div className="text-center p-8">Loading...</div>;

  return (
    <div className="max-w-5xl mx-auto py-10">
      <h2 className="text-2xl font-bold mb-6 text-center">
        🌐 M2T Social Connect Hub
      </h2>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Object.entries(links).map(([platform, url]) => (
          <a
            key={platform}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="p-4 rounded-xl border border-slate-700 bg-slate-900 hover:bg-slate-800 transition flex flex-col items-center text-center"
          >
            {platform === "youtube" && <Youtube className="w-8 h-8 text-red-500 mb-2" />}
            {platform === "twitter" && <Twitter className="w-8 h-8 text-sky-400 mb-2" />}
            {platform === "instagram" && <Instagram className="w-8 h-8 text-pink-500 mb-2" />}
            {platform === "tiktok" && <MessageSquare className="w-8 h-8 text-white mb-2" />}
            {platform === "telegram" && <Send className="w-8 h-8 text-blue-400 mb-2" />}
            <span className="font-semibold capitalize">{platform}</span>
            <span className="text-xs text-slate-400 mt-1">Visit Profile</span>
          </a>
        ))}
      </div>

      <div className="mt-10 text-sm text-slate-400 text-center max-w-lg mx-auto">
        Users can link their public social handles.  
        M2T fetches **only public data** (followers, recent posts, etc.)  
        using each platform’s official APIs — fully compliant and secure.
      </div>
    </div>
  );
}
